import { locationInfo } from "../config/siteData";
import { MapPin, Navigation } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const Location = () => {
  const { t } = useLanguage();
  
  return (
    <section
      id="lokacija"
      className="py-16 md:py-24 bg-white"
      data-testid="location-section"
    >
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-wide uppercase text-[#D4A373] mb-3 block">
            {t.location.subtitle}
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold font-['Outfit'] tracking-tight text-[#0F172A]"
            data-testid="location-title"
          >
            {t.location.title}
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            {/* Address Card */}
            <div className="bg-[#FAFAF9] rounded-2xl p-6 md:p-8 mb-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#004E64] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold font-['Outfit'] text-[#0F172A] mb-1">
                    {t.location.address}
                  </h3>
                  <p className="text-[#64748b]" data-testid="location-address">
                    {locationInfo.address}
                    <br />
                    {locationInfo.city}, {locationInfo.country}
                  </p>
                </div>
              </div>
            </div>

            {/* Description - with paragraphs */}
            <div className="text-[#64748b] leading-relaxed mb-6 space-y-4" data-testid="location-description">
              {t.location.description.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* Directions Button */}
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                `${locationInfo.address}, ${locationInfo.city}, ${locationInfo.country}`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#004E64] text-white rounded-full font-medium hover:bg-[#007A8C] transition-colors duration-200"
              data-testid="location-directions-button"
            >
              <Navigation className="w-5 h-5" />
              {t.location.openMaps}
            </a>
          </div>

          {/* Map */}
          <div className="order-1 lg:order-2">
            {locationInfo.mapPlaceholder ? (
              <div
                className="w-full h-[300px] md:h-[400px] bg-gradient-to-br from-[#e2e8f0] to-[#f1f5f9] rounded-2xl flex flex-col items-center justify-center border-2 border-dashed border-[#cbd5e1]"
                data-testid="map-placeholder"
              >
                <MapPin className="w-12 h-12 text-[#94a3b8] mb-4" />
                <p className="text-[#64748b] font-medium text-center px-4">
                  Map coming soon
                </p>
              </div>
            ) : (
              <div className="w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden shadow-lg" data-testid="map-embed">
                <iframe
                  src={locationInfo.mapEmbedUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Apartment location on map"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
